import React from "react";
import { isDesktop } from "../utils/utils";
import { useLocation, Link } from "react-router-dom";
import { primaryColor } from "../constants/colors";
import styled from "styled-components";
import { useSelector } from "react-redux";

const BottomNavBar = () => {
  const location = useLocation();
  const userData = useSelector((state) => state.appSlice.userData);
  const doctorData = useSelector((state) => state.appSlice.doctorData);

  const visiblePaths = ["/", "/patient-appointments", "/departments", "/profile", "/doctor-dashboard", "/doctor-profile", "/appointment-requests"];

  if (isDesktop || !visiblePaths.includes(location.pathname)) return null;

  const navList = doctorData
    ? [
        { name: "Home", icon: "/images/icons/ic_home.png", route: "/" },
        {
          name: "Appointments",
          icon: "/images/icons/ic_bag.png",
          route: "/doctor-dashboard",
        },
        {
          name: "Requests",
          icon: "/images/icons/list_minus.png",
          route: "/appointment-requests",
        },
        {
          name: "Profile",
          icon: "/images/icons/ic_profile.png",
          route: "/doctor-profile",
        },
      ]
    : [
        { name: "Home", icon: "/images/icons/ic_home.png", route: "/" },
        { name: "Specialists", icon: "/images/icons/ic_bag.png", route: "/departments" },
        { name: "Appointments", icon: "/images/icons/ic_list_check.png", route: "/patient-appointments" },
        { name: "Profile", icon: "/images/icons/ic_profile.png", route: "/profile" },
      ];

  return (
    <Wrapper>
      {navList.map((navItem) => (
        <Link key={navItem.name} to={navItem.route} className={`navLink ${navItem.route === location.pathname ? "active" : ""}`}>
          <img src={navItem.icon} alt="navitem icon" />
          <span>{navItem.name}</span>
        </Link>
      ))}
    </Wrapper>
  );
};

export default BottomNavBar;

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  height: 70px;
  z-index: 9999;
  display: flex;
  justify-content: space-around;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  .navLink {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.85rem;
    color: #000;
    height: 100%;
    img {
      height: 30px;
      width: 30px;
    }
  }
  .navLink.active {
    color: ${primaryColor};
    height: 100%;
    img {
      height: 30px;
      width: 30px;
      filter: invert(14%) sepia(97%) saturate(2606%) hue-rotate(196deg) brightness(92%) contrast(98%);
    }
  }
`;
